<template>
  <div class="box box-secondary">
    <div class="box-header with-border">
      <h3 class="box-title">{{'sales_stats' | translate}}</h3>
      <div class="box-tools pull-right">
        <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
        </button>
      </div>
    </div>
    <div class="box-body">
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <sales-report-chart :height="330" :dataset="shipping.data[shipping.current_page - 1]"></sales-report-chart>
          </div>
        </div>
        <div class="col-md-4">
          <hr>
          <p class="text-center">
            <strong>Marketplaces</strong>
          </p>
          <div class="progress-group">
            <span class="progress-text">amazon</span>
            <span class="progress-number"><b>
              {{Math.round(getTotal('amazon'))}}
            </b>/{{total}}</span>
            <div class="progress sm">
              <div v-if="total > 0" class="progress-bar progress-bar-warning" :style="'width:' + Math.round(getTotal('amazon') * 100 / total) + '%'"></div>
              <div v-else class="progress-bar progress-bar-warning" style="width:0%"></div>
            </div>
          </div>
          <div class="progress-group">
            <span class="progress-text">schuhe.de</span>
            <span class="progress-number"><b>
              {{Math.round(getTotal('schuhede'))}}
              </b>/{{total}}
            </span>
            <div class="progress sm">
              <div v-if="total > 0" class="progress-bar progress-bar-primary" :style="'width:' + getTotal('schuhede') * 100 / total+ '%'"></div>
              <div v-else class="progress-bar progress-bar-primary" style="width:0%"></div>
            </div>
          </div>
          <div class="progress-group">
            <span class="progress-text">zalando</span>
            <span class="progress-number"><b>
              {{Math.round(getTotal('zalando'))}}
              </b>/{{total}}
            </span>
            <div class="progress sm">
              <div v-if="total > 0" class="progress-bar progress-bar-danger" :style="'width:' + getTotal('zalando') * 100 / total+ '%'"></div>
              <div v-else class="progress-bar progress-bar-danger" style="width:0%"></div>
            </div>
          </div>
          <div class="progress-group">
            <span class="progress-text">eBay</span>
            <span class="progress-number"><b>
              {{Math.round(getTotal('ebay'))}}
              </b>/{{total}}
            </span>
            <div class="progress sm">
              <div v-if="total > 0" class="progress-bar progress-bar-info" :style="'width:' + getTotal('ebay') * 100 / total + '%'"></div>
              <div v-else class="progress-bar progress-bar-info" style="width:0%"></div>
            </div>
          </div>
          <chart-pagination :currentPage="shipping.current_page" @newTotal="triggerChanges()" :lang="$store.getters.language" :total="shipping.total" :per-page="shipping.per_page" :pagination="shipping"></chart-pagination>
        </div>
      </div>
    </div>
    <div class="box-footer">
      <div class="row">
        <stats-description :current="total" :previous="getPrevious(monthlyShippings, 'total')" :text="'total_sales'" :type="'qty'"></stats-description>
        <stats-description :current="getTotalRevenue()" :previous="getPrevious(monthlyShippings, 'order_totals')" text="total_revenue"></stats-description>
        <stats-description type="return" :current="getTotalReturns()" :previous="getPrevious(monthlyReturns, 'order_totals')" text="total_cost"></stats-description>
        <stats-description :current="getTotalRevenue() - getTotalReturns()" :previous="getPreviousCombined()" text="total_profit"></stats-description>
      </div>
    </div>
  </div>
</template>
<script>
	import VueMonthlyPicker from 'vue-monthly-picker'
	export default {
		data () {
			return {
				companies: [],
				company: {
					id: 1,
					name: 'ANWR Media GmbH'
				},
				total: 0,
				shipping: {
					total: 0,
					per_page: 25,
					current_page: 1,
					total_pages: 0,
					data: []
				},
				monthlyShippings: [],
				monthlyReturns: []
			}
		},
		components: {
			vueMonthlyPicker: VueMonthlyPicker
		},
		methods: {
			getTotal (key) {
				let total = 0
				let data = this.shipping.data[this.shipping.current_page - 1]
				for (let o in data) {
					for (let k in data[o]) {
						if (key === 'month') {
							total += data[o][k].total
						} else {
							total += data[o][k].channels[key].total
						}
					}
				}
				return total
			},
			getPrevious (array, key) {
				if (typeof this.shipping.data[this.shipping.current_page - 2] !== 'undefined') {
					let data = this.shipping.data[this.shipping.current_page - 2]
					data = Object.keys(data)[0].split('-').reverse().join('-')
					return array[data][key]
				}
				return 0
			},
			getPreviousCombined () {
				if (typeof this.shipping.data[this.shipping.current_page -2] !== 'undefined') {
					let data = this.shipping.data[this.shipping.current_page - 2]
					data = Object.keys(data)[0].split('-').reverse().join('-')
					return this.monthlyShippings[data].order_totals - this.monthlyReturns[data].order_totals
				}
				return 0
			},
			getTotalRevenue () {
				if (typeof this.shipping.data[this.shipping.current_page - 1] !== 'undefined') {
					let data = this.shipping.data[this.shipping.current_page - 1]
					data = Object.keys(data)[0].split('-').reverse().join('-')
					return data in this.monthlyShippings ? this.monthlyShippings[data].order_totals : 0
				}
				return 0
			},
			getTotalReturns () {
				if (typeof this.shipping.data[this.shipping.current_page - 1] !== 'undefined') {
					let data = this.shipping.data[this.shipping.current_page - 1]
					data = Object.keys(data)[0].split('-').reverse().join('-')
					return data in this.monthlyReturns ? this.monthlyReturns[data].order_totals : 0
				}
				return 0
			},
			triggerChanges () {
				this.total = this.getTotal('month')
			},
			processResponse (data) {
				let days = {}
				let retObj = {
					data: [],
					per_page: 25,
					current_page: 1,
					total_pages: 0,
					total: Object.keys(data).length
				}
				for (let x in data) {
					let date = x
					x = x.split('-')
					if (days[x[1] + '-' + x[0]]) {
						if (days[x[1] + '-' + x[0]][x[2]]) {
							days[x[1] + '-' + x[0]][x[2]] = data[date]
						} else {
							days[x[1] + '-' + x[0]][x[2]] = []
							days[x[1] + '-' + x[0]][x[2]] = data[date]
						}
					} else {
						days[x[1] + '-' + x[0]] = {}
						days[x[1] + '-' + x[0]][x[2]] = []
						days[x[1] + '-' + x[0]][x[2]] = data[date]
					}
				}
				Object.keys(days).forEach(key => {
					let obj = {}
					obj[key] = days[key]
					retObj.data.push(obj)
				})
				retObj.total_pages = retObj.data.length
				retObj.current_page = retObj.data.length
				this.shipping = retObj
			},
      getData () {
	      API.get(`/statistics/stats/${this.company.id}`)
		      .then(res => {
			      this.processResponse(res.data.daily_shippings)
			      this.monthlyShippings = res.data.monthly_shippings
			      this.monthlyReturns = res.data.monthly_returns
			      this.total = this.getTotal('month')
		      })
		      .catch(error => {
			      console.log(error)
		      })
      }
		},
		mounted () {
			this.companies = this.$store.getters.companies
      this.getData()
		},
		watch: {
			shipping () {
			},
			cancellations () {
			},
			returns () {
			},
			total () {
			},
			title () {
			}
		}
	}
</script>
<style>
  .date-popover {
    overflow-x: hidden;
    overflow-y: hidden;
    outline: none;
    max-width: 350px;
    width: 100%;
    border-radius: 0 0 .28571429rem .28571429rem;
    box-shadow: 0 2px 3px 0 rgba(34,36,38,.15);
    background: #212228 !important;
    transition: opacity .1s ease;
    position: relative;
    margin: auto;
    z-index: 10;
    border: 1px solid;
    font-size: 1rem;
    font-weight: 200;
  }
  .picker .monthItem .item.active:hover{
    border-top: 1px solid;
    cursor: pointer;
    background-color: rgba(0,195,150,.4) !important;
    border-color: rgba(0,195,150,1) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/SalesReport.vue